import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from './ConfigContext';
import { setConfig } from './configService';

export const ConfigProvider = ({ children }) => {
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch('/deployment-config.json', {
          cache: 'no-store',
        });

        if (!res.ok) {
          throw new Error('Failed to load config');
        }

        const data = await res.json();
        const normalizedAppConfig = {
          navigationUrl: data.NAVIGATION_URL,
          idScanUrl: data.ID_SCAN_URL,
          idScanPubKey: data.ID_SCAN_PUB_KEY,
          idScanLicenseKey: data.ID_SCAN_LICENSE_KEY,
          hostUrl: data.HOST_URL,
          idScanWebsocketUrl: data.ID_SCAN_WEBSOCKET_URL,
          plaidDevUrl: data.PLAID_DEV_URL,
          smartyStreetsWebsiteKey: data.SMARTYSTREETS_WEBSITE_KEY,
          smartyStreetEnforce: data.SMARTYSTREETS_ENFORCE,
          verificationIntervals: data.VERIFICATION_INTERVAL,
          disableManualUpload: data.DISABLE_MANUAL_UPLOAD,
          isSmartyAutofillDisabled: data.IS_SMARTY_AUTOFILL_DISABLED,
          idScanTimeout: data.ID_SCAN_TIMEOUT,
          isSmartyStreetsDisabled: data.IS_SMARTY_STREETS_DISABLED,
          pageSenseId: data.PAGESENSE_ID,
        };
        setConfig(normalizedAppConfig);
        setAppConfig(normalizedAppConfig);
      } catch (err) {
        console.error('Config load error:', err);
        setConfig({});
        setAppConfig({});
      }
    };

    loadConfig();
  }, []);

  if (!appConfig) {
    return null;
  }

  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

ConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
